import { useState, useContext, useEffect } from "react";
import DataTable from "react-data-table-component";
import { getServices } from "../../services/api";
import { AuthContext } from "../../App";

function Services() {
  const {
    settingsFormActive,
    setSettingsFormActive,
    setEvent,
    setSettingsForm,
    settingsForm,
  } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const columns = [
    {
      name: "Name",
      selector: (row) => row.service_name,
      sortable: true,
    },
  ];

  const handleRowClicked = (event) => {
    setSettingsForm("service");
    setEvent(event);
    setSettingsFormActive(true);
  };

  useEffect(() => {
    getServices().then(async (res) => {
      setData(res);
      console.log(res);
    });
  }, []);

  const handleSearch = (event) => {
    console.log(event.target.value);
    setSearchText(event.target.value);
  };

  const handleAddClick = () => {
    setSettingsForm("service");
    setEvent(null);
    setSettingsFormActive(true);
  };

  const filteredData = data.filter((item) =>
    Object.keys(item).some(
      (key) =>
        item[key] !== null &&
        item[key].toString().toLowerCase().indexOf(searchText.toLowerCase()) >
          -1
    )
  );

  return (
    <div>
      <div className="settings-component-header">
        <input
          type="text"
          value={searchText}
          onChange={handleSearch}
          placeholder="Search"
          style={{
            marginLeft: 20,
            width: 300,
          }}
        />
        <button className="booking-button" onClick={handleAddClick}>
          add
        </button>
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        highlightOnHover={true}
        striped={true}
        pointerOnHover={true}
        onRowClicked={(event) => handleRowClicked(event)}
        direction="auto"
        fixedHeader
        fixedHeaderScrollHeight="530px"
        persistTableHead
        responsive
        dense
      />
    </div>
  );
}

export default Services;
